import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptGroupMembers } from "../adapters/adaptGroupMember";

interface FetchParams {
	groupId: number;
	page: number;
	pageSize: number;
	search?: string;
}

const fetchGroupMembers = async ({
	groupId,
	page,
	pageSize,
	search
}: FetchParams) => {
	const response = await cmsClient.get<CMSPaginatedData<IGroupMember>>(
		`/users/groups/${groupId}/members/`,
		{
			params: {
				page,
				page_size: pageSize,
				search: search || undefined
			}
		}
	);

	return response.data;
};

const useGroupMembers = (params: FetchParams) => {
	return useQuery(["group-members", params], () => fetchGroupMembers(params), {
		keepPreviousData: true,
		enabled: Number.isFinite(params.groupId) && params.groupId > 0,
		select: (data) => ({
			...data,
			results: adaptGroupMembers(data.results)
		})
	});
};

export default useGroupMembers;
